<template>
  <div>
    <NuxtRouteAnnouncer />
    <NuxtPwaAssets />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
  useHead({
      titleTemplate: (t) => t ? `${t} - myLHS` : 'myLHS',
      //meta: [{ property: 'og:title', content: `GabeApp - ${route.meta.title}` }]
  });
</script>
